module.exports = __webpack_public_path__ + "static/media/you-didn’t-add-candidates-yet-.16266e01.png";